export default function NotFoundPage() {
  return (
    <div className="w-full h-screen flex justify-center items-center">
      <h1 className="text-xl font-bold text-red-500">404 - Page Not Found</h1>
    </div>
  );
}
